import axios from "axios";
import store from "@/store";
import router from "../router";
import { tansParams } from '@/utils/index';
import { getToken, removeToken } from "@/utils/auth";
import { Toast } from 'vant';

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'

// http请求超时时间
const timeout = 1200000

const service = axios.create({
	baseURL: process.env.VUE_APP_BASE_API,
	timeout: timeout
})


// 请求拦截器
service.interceptors.request.use(
	config => {
		if (store.getters.token) {
			config.headers['token'] = getToken()
			config.headers['Cache-Control'] = 'no-cache'
		}
		// get请求映射params参数
		if (config.method === 'get' && config.params) {
			let url = config.url + '?' + tansParams(config.params)
			url = url.slice(0, -1)
			config.params = {}
			config.url = url
		}
		return config
	},
	error => {
		console.log(error)
		return Promise.reject(error)
	}
)

// 返回拦截器
service.interceptors.response.use(
	response => {
		const responseType = response.config.responseType;
		if (responseType && responseType === "blob") {
			return processFile(response);
		} else {
			return processJsonData(response);
		}
	},
	error => {
		console.log('err' + error)
		let { message } = error
		if (message == 'Network Error') {
			message = '后端接口连接异常'
		} else if (message.includes('timeout')) {
			message = '系统接口请求超时'
		} else if (message.includes('Request failed with status code')) {
			message = '系统接口' + message.substr(message.length - 3) + '异常'
		}
		Toast.fail(message);
		return Promise.reject(error)
	}
);

function processJsonData(response) {
	const data = response.data
	const code = data.code
	const msg = data.msg
	//没有登录或者token失效
	if (code === 401) {
		console.log(response.data)
		removeToken();
		//重新认证登录
		var splits = location.href.split("/");
		var type = splits[splits.length - 1];
		window.location.href = process.env.VUE_APP_BASE_API +
			"extra/system/wecomauth/autologin?type=" + type;
		return new Promise(() => {});
	} else if (code !== 200) {
		Toast.fail(msg);
		return Promise.reject(new Error(msg))
	} else {
		return data
	}
}

function processFile(response) {
	const data = response.data;
	if (response.type && res.response !== "application/json") {
		try {
			const headers = response.headers;
			const contentDisposition = headers["content-disposition"];
			const filename = contentDisposition.split("=")[1];
			// saveAs(response, filename || "template.xls");
			Toast.success('下載成功');
			return Promise.resolve();
		} catch (e) {
			Toast.fail(e);
			return Promise.reject("保存文件失敗");
		}
	} else {
		const reader = new FileReader();
		reader.onload = function(event) {
			const responseStr = event.target.result;
			const jsonData = JSON.parse(responseStr);
			toast(jsonData.message || "Error");
		};
		reader.readAsText(res);
		return Promise.reject("文件下載失敗");
	}
}

export default service;